export default [
  {
    path: '/',
    name: 'home',
    component: async () => await import('@/views/irq/HomeView.vue'),
  },
  {
    path:'/create-campaign',
    name:'create-campaign',
    component:() => import('@/views/irq/CreateCampaign.vue')
  },
  {
    path:'/insert-invoice',
    name:'insert-invoice',
    component:() => import('@/views/irq/InsertInvoice.vue')
  },
  {
    meta: { title: 'menu.editCampaign' },
    path:'/campaigns/edit/:id',
    name:'edi-campaign',
    component:() => import('@/views/irq/EditCampaign.vue')
  },
  {
    meta: { title: 'menu.ratioCoin' },
    path:'/ratio-coin',
    name:'ratio-coin',
    component:() => import('@/views/irq/RatioCoins.vue')
  },
]
